module.exports = __webpack_public_path__ + "img/04.36a8c319.png";